import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/rightArrowFilled.svg'
import _imports_1 from '@/assets/downArrow.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-782ea9c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Clients")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center px-2.5" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_7 = { class: "title font-opensans text-sm w-98 flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "accordion-body bg-white"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-b border-solid border-lightgrey" }, null, -1))
const _hoisted_10 = { class: "flex justify-center flex-col px-5 pb-5 pt-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Course Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Action")
  ])
], -1))
const _hoisted_12 = { class: "font-normal whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_13 = { class: "font-normal whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_14 = { class: "switch" }
const _hoisted_15 = ["onUpdate:modelValue", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantsList, (singleclient, indexx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["text-black no-underline mt-3 moduleBox cursor-pointer", {'accordion':singleclient.isShow}]),
          key: singleclient._id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-start bg-white py-2.5 px-2.5 rounded", {
					'accordion-head':!singleclient.isShow,
					deactive: !singleclient.isActive,
					active: singleclient.isActive
				}]),
            onClick: ($event: any) => (_ctx.toggleAccordion(singleclient,indexx))
          }, [
            _createElementVNode("div", _hoisted_4, [
              (!singleclient.isShow)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6))
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(singleclient.organizationName), 1)
          ], 10, _hoisted_3),
          (singleclient.isShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock("table", {
                    key: singleclient._id
                  }, [
                    _hoisted_11,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleclient.Courses, (singleCourse) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: singleCourse._id
                        }, [
                          _createElementVNode("td", _hoisted_12, _toDisplayString(singleCourse.courseName), 1),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((singleCourse.isClientCourseActive) = $event),
                                  onClick: ($event: any) => (_ctx.onActivate(singleCourse, singleclient))
                                }, null, 8, _hoisted_15), [
                                  [_vModelCheckbox, singleCourse.isClientCourseActive]
                                ]),
                                _hoisted_16
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}